import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import ResponsiveImage from 'components/images/responsive-image'
import { ASSETS, REFERRAL_LOCIZE } from 'components/referral/landing/const'
import styles from './styles.scss'

const ReferralBanner = ({ children, t }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <div className="referral-landing-banner">
      <div className="referral-landing-banner__wrapper">
        <ResponsiveImage src={ASSETS.DESKTOP_BANNER} imgRatio={0.5625} />
      </div>
      <div className="referral-landing-banner__container">
        <div className="referral-landing-banner__content">
          <span className={Typo.title2}>
            {hasLocizeTranslation(
              t,
              REFERRAL_LOCIZE.REFERRAL_FRIENDS.key,
              REFERRAL_LOCIZE.REFERRAL_FRIENDS.text,
            )}
          </span>
          <span className={Typo.title2}>
            {hasLocizeTranslation(
              t,
              REFERRAL_LOCIZE.REFERRAL_GIVEN_OFFERS.key,
              REFERRAL_LOCIZE.REFERRAL_GIVEN_OFFERS.text,
            )}
          </span>
          <span
            className={clsx(
              'referral-landing-banner__content-detail',
              Typo.body1,
            )}
          >
            {hasLocizeTranslation(
              t,
              REFERRAL_LOCIZE.REFERRAL_GIVEN_OFFERS_DETAIL.key,
              REFERRAL_LOCIZE.REFERRAL_GIVEN_OFFERS_DETAIL.text,
            )}
          </span>
          {children}
        </div>
      </div>
    </div>
  </React.Fragment>
)

ReferralBanner.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralBanner)
